import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

let scrollLockCount = 0;
let savedScrollY = 0;

const lockBodyScroll = () => {
    if (scrollLockCount === 0) {
        savedScrollY = window.scrollY || document.documentElement.scrollTop;
        const { body, documentElement } = document;

        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${savedScrollY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        documentElement.style.overflow = 'hidden';
    }

    scrollLockCount += 1;
};

const unlockBodyScroll = () => {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount > 0) return;

    const { body, documentElement } = document;
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    documentElement.style.overflow = '';
    window.scrollTo(0, savedScrollY);
};

const Modal = ({
    isOpen,
    onClose,
    children,
    title,
    size = "medium", // small, medium, large, full
    showCloseButton = true,
    closeOnBackdropClick = true,
    overlayZIndex,
    manageBodyScroll = true
}) => {
    useEffect(() => {
        if (!manageBodyScroll || !isOpen) return undefined;

        lockBodyScroll();
        return () => {
            unlockBodyScroll();
        };
    }, [isOpen, manageBodyScroll]);

    const handleBackdropClick = (e) => {
        if (closeOnBackdropClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleEscapeKey = (e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', handleEscapeKey);
            return () => {
                document.removeEventListener('keydown', handleEscapeKey);
            };
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return createPortal(
        <div
            className="modal-overlay"
            onClick={handleBackdropClick}
            style={overlayZIndex ? { zIndex: overlayZIndex } : undefined}
        >
            <div className={`modal-container modal-${size}`}>
                <div className="modal-header-section">
                    {title && (
                        <div className="modal-title">
                            <h2>{title}</h2>
                        </div>
                    )}
                    {showCloseButton && (
                        <button
                            type="button"
                            className="modal-close-button"
                            onClick={onClose}
                            aria-label="Cerrar modal"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    )}
                </div>
                <div className="modal-content">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
